import { joinDataTestId } from "@/constants/data-test-ids.utils";

export const weekGridDataTestIds = {
  component: "week-grid" as const,
  container: (): string => joinDataTestId(weekGridDataTestIds.component, "container"),
  // États
  loadingSkeletons: (): string => joinDataTestId(weekGridDataTestIds.component, "loading-skeletons"),
  errorMessage: (): string => joinDataTestId(weekGridDataTestIds.component, "error-message"),
  // Bannière flex
  flexBanner: (): string => joinDataTestId(weekGridDataTestIds.component, "flex-banner"),
  flexBannerIcon: (): string => joinDataTestId(weekGridDataTestIds.component, "flex-banner-icon"),
  flexBannerMessage: (): string => joinDataTestId(weekGridDataTestIds.component, "flex-banner-message"),
  flexBannerBtn: (): string => joinDataTestId(weekGridDataTestIds.component, "flex-banner-btn"),
  // Grille des jours
  daysContainer: (): string => joinDataTestId(weekGridDataTestIds.component, "days-container"),
  dayColumn: (dateISO: string): string => joinDataTestId(weekGridDataTestIds.component, "day-column", dateISO),
  dayHeader: (dateISO: string): string => joinDataTestId(weekGridDataTestIds.component, "day-header", dateISO),
  dayName: (dateISO: string): string => joinDataTestId(weekGridDataTestIds.component, "day-name", dateISO),
  dayMonth: (dateISO: string): string => joinDataTestId(weekGridDataTestIds.component, "day-month", dateISO),
  daySlotsContainer: (dateISO: string): string =>
    joinDataTestId(weekGridDataTestIds.component, "day-slots-container", dateISO),
  noAvailabilitiesMessage: (dateISO: string): string =>
    joinDataTestId(weekGridDataTestIds.component, "no-availabilities-message", dateISO),
};
